import styled from "styled-components";
import {
  Checkbox as CheckboxUI,
  DialogActions as DialogActionsUI,
  DialogTitle as DialogTitleUI,
  H2,
} from "@evergis/ui";

import { DialogContent as DialogContentUI } from "../DialogComponents/styled";

export const DialogTitle = styled(DialogTitleUI)`
  justify-content: space-between;
  padding-bottom: 0;
  padding-left: 3rem;

  ${H2} {
    margin: 0;
  }
`;

export const DialogContent = styled(DialogContentUI)`
  align-items: start;
  padding-left: 3rem;
  padding-right: 3rem;
  box-sizing: border-box;
`;

export const DialogActions = styled(DialogActionsUI)`
  padding: 1rem 3rem 3rem;
`;

export const TextLine = styled.div`
  margin: 0;
`;

export const TooltipTextLine = styled(TextLine)`
  max-width: 8.5rem;
  white-space: nowrap;
  overflow: hidden;
  font-weight: normal;
`;

export const TooltipGroupItem = styled.div`
  &:not(:first-child) {
    margin-top: 0.5rem;
  }
`;

export const TooltipGroup = styled.span`
  opacity: 0.54;
  margin-bottom: 0.25rem;
`;

export const Checkbox = styled(CheckboxUI)`
  margin-bottom: 0.5rem !important;
`;

export const CheckboxDescription = styled.div`
  font-size: 0.75rem;
  margin-left: 1.75rem;
  margin-bottom: 1.5rem;

  span {
    opacity: 0.54;
  }

  abbr {
    cursor: pointer;
    border-bottom: 1px dotted rgba(0, 0, 0, 0.54);
  }
`;
